import React from "react";
import { FaStar } from "react-icons/fa";
import { MdOutlineStarBorderPurple500 } from "react-icons/md";
import { IoMdStar, IoMdStarOutline } from "react-icons/io";

export default function FeedbackModal(props) {
  const {
    employeeName = "Avinash Gupta",
    employeeInitial = "A",
    submitFeedback,
    closeFeedback,
    feedbackSaveList = [],
    handleFeedbackUpdate
  } = props;

  const handleSubmit = () => {
    submitFeedback(feedbackSaveList);
  };


  // console.log("feedbackSaveList--xyz---", feedbackSaveList)

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex justify-center items-center">
      <div className="bg-white rounded-xl shadow-xl w-[95%] max-w-5xl">

        {/* Header */}
        <div className="flex justify-between items-center border-b px-6 py-4">
          <h2 className="text-xl font-semibold">Give Feedback</h2>

          <button
            onClick={() => closeFeedback(false)}
            className="h-9 w-9 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500"
          >
            ✕
          </button>
        </div>

        {/* Employee */}
        <div className="px-6 pt-5">
          <div className="flex items-center gap-3 bg-indigo-50 rounded-lg p-3">
            <div className="w-10 h-10 rounded-full bg-indigo-600 text-white flex items-center justify-center font-bold">
              {employeeInitial}
            </div>

            <div className="font-semibold text-gray-700">
              {employeeName}
            </div>
          </div>
        </div>

        {/* Body */}
        <div className="px-6 py-5 max-h-[500px] overflow-y-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            {feedbackSaveList.map((item, index) => (
              <div key={index} className="border rounded-lg bg-indigo-50/40">
                <div className="flex justify-between items-center p-3 border-b">
                  <div className="font-semibold text-gray-700">
                    {item.dimension}
                  </div>

                  <div className="flex gap-1">
                    {/* {[1, 2, 3, 4, 5].map((star) => (
                      <MdOutlineStarBorderPurple500
                        key={star}
                        size={24}
                        className={`cursor-pointer transition ${star <= item.rating
                          ? "text-amber-500"
                          : "text-amber-500"
                          }`}
                        onClick={() =>
                          handleFeedbackUpdate(item.dimension, "rating", star)
                        }
                      />
                    ))} */}

                    {[1, 2, 3, 4, 5].map((star) => (
                      <span
                        key={star}
                        onClick={() =>
                          handleFeedbackUpdate(item.dimension, "rating", star)
                        }
                        className="cursor-pointer transition"
                      >
                        {star <= item.rating ? (
                          <IoMdStar size={24} className="text-amber-500" />
                        ) : (
                          <IoMdStarOutline size={24} className="text-amber-500" />
                        )}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="p-3">
                  <textarea
                    rows={3}
                    value={item.feedback}
                    placeholder="Write feedback here..."
                    onChange={(e) =>
                      handleFeedbackUpdate(item.dimension, "feedback", e.target.value)
                    }
                    className="w-full border rounded-lg p-3 resize-none outline-none focus:ring-2 focus:ring-indigo-500"
                  />
                </div>
              </div>
            ))}

          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 border-t px-6 py-4">
          <button onClick={() => closeFeedback(false)} className="px-6 py-2 font-medium border rounded-md hover:bg-gray-100">Cancel</button>
          <button onClick={handleSubmit} className="px-8 py-2 font-medium rounded-md bg-indigo-600 hover:bg-indigo-700 text-white">Save Feedback</button>
        </div>

      </div>
    </div>
  );
}